import * as URLParser from "./urlparser";

export function loadUrlContext( url ){

    return new Promise( function(resolve){
        var urlParams = URLParser.getParams(url, false);
        if(!urlParams.search){
            throw new Error("Missing url parameters");
        }

        var options = {};

        // Get a bunch of the params of type Number
        var numberParams = ['campusid','zlevel','bearing'];
        var param;
        for(var i = 0; i < numberParams.length; i++){
            param = numberParams[i];
            if(!urlParams.search[param]){
                throw new Error("Missing url parameter: " + param);
            }
            options[param] = Number(urlParams.search[param]);
        }

        // Get center parameter, which is comma-seperated lngLat property
        var center = urlParams.search['center'];
        if(!center){
            throw new Error("Missing url parameter: center");
        }
        center = decodeURIComponent(center).split(',');
        center = {lng: Number(center[0]), lat: Number(center[1])};
        options.center = center;


        // Get placement of "kiosk position" parameter, which is comma-seperated lngLat property
        // This is optional, and will default to the required "center" property
        var kioskcenter = urlParams.search['kioskcenter'];
        if(!kioskcenter){
            options.kioskcenter = center;
        }else{
            kioskcenter = decodeURIComponent(kioskcenter).split(',');
            kioskcenter = {lng: Number(kioskcenter[0]), lat: Number(kioskcenter[1])};
            options.kioskcenter = kioskcenter;
        }


        // Get zoom property
        var zoom = Number(urlParams.search['zoom']);
        if(!zoom){
            zoom = 19; // default value
        }
        options.zoom = zoom;

        // Get pitch property
        var pitch = urlParams.search['pitch'];
        if(!pitch){
            pitch = 20; // default value
        }
        options.pitch = pitch;

        // Get optional timeout property
        var timeout = String(urlParams.search['timeout']);
        if(timeout === 'false' || timeout === '0' ) {
            timeout = 0;
        } else if( Number(timeout) ) {
            timeout = Number(timeout);
        } else {
            timeout = 60; // Default value, in seconds
        }
        options.timeout = timeout;


        // Get optional defined poitypes. example: poitypes=13,4,2
        var poitypes = urlParams.search['poitypes'];
        if(poitypes){
            options.poitypes = poitypes.split(',').map( Number );
        }

        // Get optional defined layout. example: layout=vertical
        var layout = urlParams.search['layout'];
        options.layout = layout || 'horizontal';

        // Get optional defined buildingid. example: buildingid=2
        // Locks the kiosk in a state relative to a single building
        var buildingid = urlParams.search['buildingid'];
        if(buildingid){
            options.buildingid = Number(buildingid);
        }

        // Allow override of analytics tracking
        // by checking the analytics parameter
        var analytics = urlParams.search['analytics'];
        if(analytics === 'off'){
            options.analytics = false;
        }else{
            options.analytics = true;
        }

        var configmode = urlParams.search['configmode'];

        if(configmode === 'true'){
            options.configmode = true;
        }else{
            options.configmode = false;
        }

        resolve( options );

    } );
}


// WEBPACK FOOTER //
// src/kiosk/Context/context.js